import Component from '../../lib/component'
import Scroller from '../../lib/scroller'
import HashAnchorComponent from '../hash-anchor/hash-anchor'
import { RootComponent } from '../../main'

export default class HashAnchorNavComponent extends Component {
    static selector () {
        return '.hash-anchor-nav'
    }

    constructor (opts) {
        super(opts)

        this.Scroller = new Scroller({ el: this.el })
        this.addFeaturesToClassName()

        this.render()
        this.listen()

        setTimeout(() => !this.getStickyBarParent()
                || this.isStickyBarParentVisible()
            ? this.scrollActiveNavItemIntoView()
            : null,
        1000)
    }

    listen () {
        this.getHashAnchors()
            .forEach(el => el
                .addEventListener('click', (e) => !this.isScrollingTo()
                    ? this.setActiveNavItem(this.getNavItems()
                        .filter(_el => _el.contains(el)
                            || _el === el)[0])
                    : null))

        RootComponent.Scroller.state
            .on('update', this.onScroll.bind(this))

        this.Scroller.state
            .on('update', this.onNavScroll.bind(this))

        this.on('resize', () => {
            this.onScroll()
            this.onNavScroll()
        })
    }

    onScroll (e) {
        if (this.isScrollingTo()
                || (this.getStickyBarParentDuplicateSibling()
                    && !this.isStickyBarParentVisible()))
            return

        const els = this.getElsFromHashAnchors()

        if (!els.length)
            return

        const currentData = ((e || {}).data || {}).currentData
            || RootComponent.Scroller.state.get()

        if (currentData.scrollY < els[0].offsetTop)
            return this.resetActiveNavItem()

        let activeNavItemAnchor
        let activeNavItem

        for (let idx = 0; idx < els.length; idx += 1) {
            const bounds = els[idx].getBoundingClientRect()

            const boundsNext = els[idx + 1]
                ? els[idx + 1].getBoundingClientRect()
                : null

            if (Math.floor(bounds.top - this.getScrollYOffset(els[idx])) <= 0
                    && (!boundsNext
                        || Math.floor(boundsNext.top
                            - this.getScrollYOffset(els[idx + 1])) > 0)) {
                activeNavItemAnchor = (this.el
                    .querySelector(`a[href$="#${els[idx].id}"]`) || {})

                activeNavItem = this.getNavItems()
                    .filter(el => el.contains(activeNavItemAnchor)
                        || el === activeNavItemAnchor)[0]

                break
            }
        }

        if (!activeNavItemAnchor
                || !activeNavItem
                || activeNavItem.classList
                    .contains('hash-anchor-nav-item-active'))
            return

        this.setActiveNavItem(activeNavItem)
    }

    onNavScroll (e) {
        const navScrollX = this.Scroller.state.get('scrollX')
        const navScrollY = this.Scroller.state.get('scrollY')

        if (this.props.scrollx !== String(navScrollX))
            this.props.scrollx = navScrollX

        if (this.props.scrolly !== String(navScrollY))
            this.props.scrolly = navScrollY

        if (!this.isStickyBarParentVisible())
            return

        const stickyBarDuplicate = this.getStickyBarParentDuplicateSibling()

        Array.from(stickyBarDuplicate.querySelectorAll('.hash-anchor-nav'))
            .filter(el => el.getAttribute('data-instance-id')
                === this.props.instanceId)
            .forEach(el => {
                el.scrollLeft = this.el.scrollLeft
                el.scrollTop = this.el.scrollTop
            })
    }

    isHorizontal () {
        return this.props.horizontal === 'true'
    }

    isScrollingTo () {
        return RootComponent.Scroller.scrollingTo
            || document.documentElement
                .getAttribute('data-scrolling-to') === 'true'
            || this.Scroller.scrollingTo
            || this.el.getAttribute('data-scrolling-to') === 'true'
    }

    isStickyBarParentClone () {
        return this.getStickyBarParent()
            && this.getStickyBarParent()
                .classList.contains('sticky-bar-clone')
    }

    isStickyBarParentVisible () {
        const stickyBar = this.getStickyBarParent()
        const stickyBarDuplicate = this.getStickyBarParentDuplicateSibling()

        if (!stickyBar || !stickyBarDuplicate)
            return false

        const isStickyBarParentClone = this.isStickyBarParentClone()

        return (isStickyBarParentClone
                && this.isElementComputedStyleVisible(this.el))
            || (!isStickyBarParentClone
                    && (stickyBar.getAttribute('data-sticky') === 'true'
                        || stickyBar.getAttribute('data-sticky-disabled')
                            === 'true'))
    }

    getElsFromHashAnchors () {
        return this.getHashAnchors()
            .filter(el => el && el.hash)
            .map(el => document.querySelector(el.hash))
            .filter(el => el)
    }

    getHashAnchors () {
        return Array.from(
            this.el.querySelectorAll(HashAnchorComponent.selector()))
    }

    getNavItems () {
        return Array.from(
            this.el.querySelectorAll('.hash-anchor-nav-item'))
    }

    getActiveNavItem (queryEl = this.el) {
        return queryEl
            .querySelector('.hash-anchor-nav-item-active')
    }

    getStickyBarParent () {
        let stickyBar
        let stickyBarParentEl = this.el.parentElement

        while (!stickyBar && stickyBarParentEl !== document.body) {
            if (stickyBarParentEl.classList.contains('sticky-bar-clone')
                    || stickyBarParentEl.classList.contains('sticky-bar')) {
                stickyBar = stickyBarParentEl
                break
            }

            stickyBarParentEl = stickyBarParentEl.parentElement
        }

        return stickyBar
    }

    getStickyBarParentDuplicateSibling () {
        const isStickyBarParentClone = this.isStickyBarParentClone()
        const stickyBar = this.getStickyBarParent()

        if (!stickyBar)
            return

        let stickyBarDuplicate

        if (isStickyBarParentClone
                && stickyBar.nextElementSibling
                && stickyBar.nextElementSibling
                    .getAttribute('data-sticky-scroll-listener-selector')
                        === `#${stickyBar.id}`)
            stickyBarDuplicate = stickyBar.nextElementSibling

        if (!isStickyBarParentClone
                && stickyBar.previousElementSibling
                && `#${stickyBar.previousElementSibling.id}`
                    === stickyBar
                        .getAttribute('data-sticky-scroll-listener-selector'))
            stickyBarDuplicate = stickyBar.previousElementSibling

        return stickyBarDuplicate
    }

    getScrollYOffset (el = this.getElsFromHashAnchors()[0]) {
        const stickyBars = Array.from(document
            .querySelectorAll('.sticky-bar'))
            .filter(_el => {
                if (!el
                        || !_el.offsetHeight
                        || _el.getAttribute('data-sticky-disabled') === 'true')
                    return

                const selector = _el
                    .getAttribute('data-sticky-scroll-listener-selector')

                const stickyEl = selector
                    ? document.querySelector(selector)
                    : _el

                const stickyBounds = stickyEl.getBoundingClientRect()
                const targetBounds = el.getBoundingClientRect()

                return targetBounds.top > stickyBounds.bottom
            })
            .map(el => el.offsetHeight)

        const stickyBarsOffset = stickyBars.length
            ? stickyBars
                .reduce((accumulator, currentValue) =>
                    accumulator + currentValue)
            : 0

        const getComputedStyleInt = (_el, prop) => Number(
            (window.getComputedStyle(_el)[prop] || '0')
                .replace(/[a-z]/ig, ''))

        return stickyBarsOffset
            + getComputedStyleInt(document.documentElement, 'paddingTop')
            + getComputedStyleInt(document.documentElement, 'marginTop')
            + getComputedStyleInt(document.body, 'paddingTop')
            + getComputedStyleInt(document.body, 'marginTop')
    }

    resetActiveNavItem (queryEl = this.el) {
        if (!this.getActiveNavItem(queryEl))
            return

        Array.from(queryEl.querySelectorAll('.hash-anchor-nav-item-active'))
            .forEach(el => {
                el.classList.remove('hash-anchor-nav-item-active')

                const anchor = el.tagName === 'A'
                    ? el
                    : el.querySelector('a')

                if (anchor)
                    anchor.removeAttribute('aria-current')
            })
    }

    setActiveNavItem (el, queryEl = this.el) {
        if (!el
                || this.getActiveNavItem(queryEl) === el
                || (this.getActiveNavItem(queryEl)
                    && this.getActiveNavItem(queryEl)
                        .contains(el)))
            return

        if (this.getActiveNavItem(queryEl))
            this.resetActiveNavItem(queryEl)

        if (!el.classList.contains('hash-anchor-nav-item-active'))
            el.classList
                .add('hash-anchor-nav-item-active')

        const anchor = el.tagName === 'A'
            ? el
            : el.querySelector('a')

        if (anchor)
            anchor
                .setAttribute('aria-current', true)

        const stickyBarDuplicate = this.getStickyBarParentDuplicateSibling()

        const stickyBarDuplicateAnchor = stickyBarDuplicate
                && queryEl !== stickyBarDuplicate
                && anchor
                && anchor.hash
            ? stickyBarDuplicate.querySelector(`a[href="${anchor.hash}"]`)
            : null

        // Sync Duplicate Navs in Sticky Bars
        if (stickyBarDuplicateAnchor) {
            let stickyBarDuplicateItem = stickyBarDuplicateAnchor

            const isNavItem = (_el) =>
                _el.classList.contains('hash-anchor-nav-item')
                    || _el.parentElement.classList.contains('hash-anchor-nav')

            while (stickyBarDuplicateItem !== document.body) {
                if (isNavItem(stickyBarDuplicateItem))
                    break

                stickyBarDuplicateItem = stickyBarDuplicateItem.parentElement
            }

            if (isNavItem(stickyBarDuplicateItem))
                this.setActiveNavItem(
                    stickyBarDuplicateItem, stickyBarDuplicate)
        }

        const isVisible = !stickyBarDuplicate
            || (this.isStickyBarParentVisible()
                && this.el.contains(el))

        if (!isVisible)
            return

        this.scrollActiveNavItemIntoView()
    }

    scrollActiveNavItemIntoView () {
        const activeItem = this.getActiveNavItem()

        if (!activeItem
                || !this.isHorizontal()
                || this.el.clientWidth >= this.el.scrollWidth
                || this.Scroller.scrollingTo)
            return

        const navScrollX = this.el.scrollLeft
        const navBounds = this.el.getBoundingClientRect()
        const activeItemBounds = activeItem.getBoundingClientRect()

        let scrollX = -1

        if (activeItemBounds.right > navBounds.right)
            scrollX = navScrollX
                + ((activeItemBounds.left + activeItem.clientWidth)
                    - this.el.clientWidth
                    - navBounds.left)

        if (activeItemBounds.left < navBounds.left)
            scrollX = !Array.from(this.el.children).indexOf(activeItem)
                ? 0
                : Math.floor((navScrollX - Math.floor(navBounds.left))
                    + activeItemBounds.left)

        if (scrollX < 0)
            return

        if ('scrollTo' in this.el)
            this.el.scrollTo(scrollX, 0)
    }

    render () {
        const stickyBarDuplicate = this.getStickyBarParentDuplicateSibling()

        const stickyBarDuplicateNav = stickyBarDuplicate
            ? Array.from(stickyBarDuplicate.querySelectorAll('.hash-anchor-nav'))
                .filter(el => el.innerHTML === this.el.innerHTML)[0]
            : null

        if (stickyBarDuplicateNav) {
            this.props.instanceId = this.generateGUID()

            stickyBarDuplicateNav
                .setAttribute('data-instance-id', this.props.instanceId)
        }

        const getAnchorHtml = (text) => `
            <span
                class="hash-anchor-nav-item-text"
            ><span>${text}</span></span>
            <span
                class="hash-anchor-nav-item-text-horizontal-sizer"
            >${text}</span>`
            .replace(/(\s{2,}|\n)/g, ' ')

        Array.from(this.el.children)
            .forEach(el => {
                if (!el.classList.contains('hash-anchor-nav-item'))
                    el.classList.add('hash-anchor-nav-item')

                const anchor = el.tagName === 'A'
                    ? el
                    : el.children[0]

                if (anchor
                        && (anchor.innerText === anchor.innerHTML
                            || (!anchor.innerText
                                && anchor.innerHTML)))
                    anchor.innerHTML = getAnchorHtml(anchor.innerHTML)
            })

        const dynamicNavItems = this.props.navItemFromSelector
            ? Array.from(document.querySelectorAll(this.props.navItemFromSelector))
            : []

        if (!dynamicNavItems.length) {
            this.onScroll()
            this.props.ready = true

            return
        }

        const slugify = (text) => {
            const a = 'àáäâèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
            const b = 'aaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
            const p = new RegExp(a.split('').join('|'), 'g')

            return String(text)
                .toLowerCase()
                .replace(/\s+/g, '-')
                .replace(p, c =>
                    b.charAt(a.indexOf(c)))
                .replace(/&/g, '-and-')
                .replace(/[^\w-]+/g, '')
                .replace(/-+/g, '-')
                .replace(/^-+/, '')
                .replace(/-+$/, '')
                .replace(/^[^a-z]+/, '')
        }

        dynamicNavItems
            .forEach(el => {
                if (!el.id && el.innerText) {
                    const slug = slugify(el.innerText)
                    let id = slug
                    let i = 1

                    while (document.querySelector(`#${id}`)) {
                        id = `${slug}-${i}`
                        i++
                    }

                    el.id = id
                }

                if (!el.getAttribute('tabindex'))
                    el.setAttribute('tabindex', -1)

                const tagName = this.props.navItemTagname
                        && this.props.navItemTagname !== 'a'
                    ? this.props.navItemTagname
                    : 'div'

                const className = ` class="hash-anchor-nav-item${
                    this.props.navItemClassname
                        ? ` ${this.props.navItemClassname}`
                        : ''}"`

                this.el.innerHTML += `
                    <${tagName}${className}>
                        <a href="#${el.id}">
                            ${getAnchorHtml(el.innerText)}
                        </a>
                    </${tagName}>`
                    .replace(/(\s{2,}|\n)/g, ' ')
            })

        this.onScroll()
        this.props.ready = true
    }
}
